import Icons from 'assets/icons'
import images from 'assets/images/images'
import NavbarTab from 'components/navbar/navbarItem/NavbarTab'
import useTranslate from 'hooks/useTranslate'
import React, {useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import auth from 'utils/Auth'
import {dataLayerPush} from 'utils/Datalayer'

const HamburgerMenu = () => {
    const {t} = useTranslate()
    const [openMenu, setOpenMenu] = useState(false)
    const closeRef = useRef(null)
    const navigate = useNavigate();
    const { userInfo } = useSelector(state => state.general)
    const redirectFunc = (id, url) => {
        if (id == 3) {
            let cookiesAccept  = auth?.getCookieAcception();
            localStorage.clear();
            sessionStorage.clear();
            dataLayerPush({
                event:"log_out",
                user_id:userInfo?.id,
                user_phone:userInfo?.phone,
                user_email :userInfo?.email,
            })
            if(cookiesAccept){
                auth.setCookieAcception(cookiesAccept)
            }
            window.location = url
        } else {
            navigate(url)
        }
        setOpenMenu(!openMenu)

    }
    const menuFunc = () => {
        setOpenMenu(!openMenu)
    }
    const menuItems = [
        {
            name: t('myAccount'),
            icon: images.profile,
            id: 0,
            url: "/hesabim"
        },
        {
            name: t('myAddresses'),
            icon: images.pinmapOrange,
            id: 1,
            url: "/adreslerim"
        },
        {
            name: t('myorders'),
            icon: images.receipt,
            id: 2,
            url: "/siparislerim"
        },
        {
            name: t('logoutBtn'),
            icon: images.logout,
            id: 3,
            url: "/"
        },
    ]
    const closeOpenMenus = (e)=>{
        if(closeRef.current && openMenu && !closeRef.current.contains(e.target)){
          setOpenMenu(false)
        }
    }
    document.addEventListener('mousedown',closeOpenMenus)
	const parameters = auth.getUserChoises();
    const isSearchOpen = parameters?.deliveryType &&
    parameters?.neighbourhoodId &&
    parameters?.restaurantId &&
    (parameters?.deliveryType == 1 || parameters?.regionId)
  return (
    <div className='navbar-profile'>
           
            <div onClick={menuFunc} className="navbar-profile-menu-wrapper">
                <img  src={images.hamburger} alt="" />
            </div>
            {
                openMenu && <div ref={closeRef} className="navbar-profile-menu">
                     {
                        auth.isHaveToken() && <div className="navbar-profile-menu-tabs">
                            <NavbarTab isSearchOpen={isSearchOpen}/>
                        </div>
                     }
                    <div className='navbar-profile-menu-item restaurantName'>
                      <Icons.location size={22}/>
                      <div className='body-m'>{auth?.getUserChoises()?.restaurantName}</div> 
                    </div>
                    
                    {
                        menuItems.map((menu, i) => (
                            <div onClick={() => redirectFunc(menu.id, menu.url)} key={i} className='navbar-profile-menu-item'>
                                <img src={menu.icon} alt="" />
                                <div className='d-flex flex-column'><span>{menu.name}</span> <span>{i == 0 && `${userInfo?.fullName}`}</span></div>

                            </div>
                        ))
                    }
                </div>
            }

        </div>
  )
}

export default HamburgerMenu